module.exports = __webpack_public_path__ + "img/b.55a06acb.jpg";